import { createSelector } from 'reselect';
import { AVAILABILITY_STATUS_EDIT } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const getHasAvailabilityStatusEditAccess = createSelector(getScopes, scopes => scopes.includes(AVAILABILITY_STATUS_EDIT));